/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { UpdateCompositionsDetailMutationRequest, UpdateCompositionsDetailMutationResponse, UpdateCompositionsDetailPathParams } from "../models/UpdateCompositionsDetail";

export function getUpdateCompositionsDetailUrl(id: UpdateCompositionsDetailPathParams["id"]) {
  const res = { method: 'PATCH', url: `/compositions/${id}` as const }
  return res
}

/**
 * @summary Update a composition by id
 * {@link /compositions/:id}
 */
export async function updateCompositionsDetail(id: UpdateCompositionsDetailPathParams["id"], data: UpdateCompositionsDetailMutationRequest, config: Partial<RequestConfig<UpdateCompositionsDetailMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, UpdateCompositionsDetailMutationRequest>({ method : "PATCH", url : getUpdateCompositionsDetailUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}